import {
  CURRENCY_MANAGER_ACTIVE,
  CURRENCY_MANAGER_ACTIVE_FAIL,
  CURRENCY_MANAGER_ACTIVE_RESET,
  CURRENCY_MANAGER_ACTIVE_SUCCESS,
  CURRENCY_MANAGER_CREATE,
  CURRENCY_MANAGER_CREATE_FAIL,
  CURRENCY_MANAGER_CREATE_RESET,
  CURRENCY_MANAGER_CREATE_SUCCESS,
  CURRENCY_MANAGER_DELETE,
  CURRENCY_MANAGER_DELETE_FAIL,
  CURRENCY_MANAGER_DELETE_RESET,
  CURRENCY_MANAGER_DELETE_SUCCESS,
  CURRENCY_MANAGER_DETAIL,
  CURRENCY_MANAGER_DETAIL_FAIL,
  CURRENCY_MANAGER_DETAIL_RESET,
  CURRENCY_MANAGER_DETAIL_SUCCESS,
  CURRENCY_MANAGER_LIST,
  CURRENCY_MANAGER_LIST_COLUMN,
  CURRENCY_MANAGER_LIST_FAIL,
  CURRENCY_MANAGER_LIST_RESET,
  CURRENCY_MANAGER_LIST_SUCCESS,
  CURRENCY_MANAGER_ROLE_LIST,
  CURRENCY_MANAGER_ROLE_LIST_FAIL,
  CURRENCY_MANAGER_ROLE_LIST_RESET,
  CURRENCY_MANAGER_ROLE_LIST_SUCCESS,
  CURRENCY_MANAGER_UPDATE,
  CURRENCY_MANAGER_UPDATE_FAIL,
  CURRENCY_MANAGER_UPDATE_RESET,
  CURRENCY_MANAGER_UPDATE_SUCCESS,
} from "./actionTypes";

const INIT_STATE = {
  // List User
  list: {
    items: [],
    totalCount: 0,
    columnsVisible: null,
    params: {
      sizePerPage: 10,
      page: 1,
      sort: "-maker_date",
      columnFilter: {}, // Column filter
      keywords: "", // Input search all
    },
  },
  loadingList: false,
  errorList: null,

  // List User Role
  listRole: { items: [], params: {} },
  loadingListRole: false,
  errorListRole: null,

  // Create User
  create: null,
  loadingCreate: false,
  errorCreate: null,

  // Detail User
  detail: null,
  loadingDetail: false,
  errorDetail: null,

  // Update User
  update: null,
  loadingUpdate: false,
  errorUpdate: null,

  // Delete User
  delete: null,
  loadingDelete: false,
  errorDelete: null,

  // Active User
  active: null,
  loadingActive: false,
  errorActive: null,
};

const userManagement = (state = INIT_STATE, action) => {
  switch (action.type) {
    // List User
    case CURRENCY_MANAGER_LIST:
      return {
        ...state,
        loadingList: true,
        errorList: null,
      };
    case CURRENCY_MANAGER_LIST_SUCCESS:
      return {
        ...state,
        loadingList: false,
        errorList: null,
        list: {
          ...state.list,
          items: action.payload.items,
          totalCount: action.payload._meta
            ? action.payload._meta.totalCount
            : action.payload.items.length,
        },
      };
    case CURRENCY_MANAGER_LIST_FAIL:
      return { ...state, loadingList: false, errorList: action.payload };
    case CURRENCY_MANAGER_LIST_RESET:
      return {
        ...state,
        loadingList: false,
        errorList: null,
        list: {
          ...state.list, // columnsVisible
          items: [],
          totalCount: 0,
          params: {
            sizePerPage: 10,
            page: 1,
            sort: "-maker_date",
            columnFilter: {},
            keywords: "",
          },
        },
      };
    case CURRENCY_MANAGER_LIST_COLUMN:
      const currentColumns = state.list.columnsVisible || {};
      currentColumns[action.payload.field] = action.payload.value;
      return {
        ...state,
        list: { ...state.list, columnsVisible: currentColumns },
      };

    // List User Role
    case CURRENCY_MANAGER_ROLE_LIST:
      return {
        ...state,
        loadingListRole: true,
        errorListRole: null,
      };
    case CURRENCY_MANAGER_ROLE_LIST_SUCCESS:
      return {
        ...state,
        loadingListRole: false,
        errorListRole: null,
        listRole: { ...state.listRole, items: action.payload },
      };
    case CURRENCY_MANAGER_ROLE_LIST_FAIL:
      return {
        ...state,
        loadingListRole: false,
        errorListRole: action.payload,
      };
    case CURRENCY_MANAGER_ROLE_LIST_RESET:
      return {
        ...state,
        loadingListRole: false,
        errorListRole: null,
        listRole: { items: [], params: {} },
      };

    // Create User
    case CURRENCY_MANAGER_CREATE:
      return {
        ...state,
        loadingCreate: true,
        errorCreate: null,
      };
    case CURRENCY_MANAGER_CREATE_SUCCESS:
      return {
        ...state,
        loadingCreate: false,
        errorCreate: null,
        create: { ...action.payload, success: true },
      };
    case CURRENCY_MANAGER_CREATE_FAIL:
      return { ...state, loadingCreate: false, errorCreate: action.payload };
    case CURRENCY_MANAGER_CREATE_RESET:
      return {
        ...state,
        loadingCreate: false,
        errorCreate: null,
        create: null,
      };

    // Detail User
    case CURRENCY_MANAGER_DETAIL:
      return {
        ...state,
        loadingDetail: true,
        errorDetail: null,
      };
    case CURRENCY_MANAGER_DETAIL_SUCCESS:
      return {
        ...state,
        loadingDetail: false,
        errorDetail: null,
        detail: { ...action.payload, success: true },
      };
    case CURRENCY_MANAGER_DETAIL_FAIL:
      return { ...state, loadingDetail: false, errorDetail: action.payload };
    case CURRENCY_MANAGER_DETAIL_RESET:
      return {
        ...state,
        loadingDetail: false,
        errorDetail: null,
        detail: null,
      };

    // Update User
    case CURRENCY_MANAGER_UPDATE:
      return {
        ...state,
        loadingUpdate: true,
        errorUpdate: null,
      };
    case CURRENCY_MANAGER_UPDATE_SUCCESS:
      return {
        ...state,
        loadingUpdate: false,
        errorUpdate: null,
        update: { ...action.payload, success: true },
      };
    case CURRENCY_MANAGER_UPDATE_FAIL:
      return { ...state, loadingUpdate: false, errorUpdate: action.payload };
    case CURRENCY_MANAGER_UPDATE_RESET:
      return {
        ...state,
        loadingUpdate: false,
        errorUpdate: null,
        update: null,
        create: null,
      };

    // Delete User
    case CURRENCY_MANAGER_DELETE:
      return {
        ...state,
        loadingDelete: true,
        errorDelete: null,
      };
    case CURRENCY_MANAGER_DELETE_SUCCESS:
      return {
        ...state,
        loadingDelete: false,
        errorDelete: null,
        delete: { success: true },
      };
    case CURRENCY_MANAGER_DELETE_FAIL:
      return {
        ...state,
        loadingDelete: false,
        errorDelete: action.payload,
      };
    case CURRENCY_MANAGER_DELETE_RESET:
      return {
        ...state,
        loadingDelete: false,
        errorDelete: null,
        delete: null,
      };

    // Active User
    case CURRENCY_MANAGER_ACTIVE:
      return {
        ...state,
        loadingActive: true,
        errorActive: null,
      };
    case CURRENCY_MANAGER_ACTIVE_SUCCESS:
      return {
        ...state,
        loadingActive: false,
        errorActive: null,
        active: { ...action.payload, success: true },
      };
    case CURRENCY_MANAGER_ACTIVE_FAIL:
      return {
        ...state,
        loadingActive: false,
        errorActive: action.payload,
      };
    case CURRENCY_MANAGER_ACTIVE_RESET:
      return {
        ...state,
        loadingActive: false,
        errorActive: null,
        active: null,
      };

    default:
      return state;
  }
};

export default userManagement;
